import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavController, AlertController, MenuController } from 'ionic-angular';
import { MeteorObservable } from 'meteor-rxjs';
import * as _ from 'lodash';
import { Events } from 'ionic-angular/util/events';
import { Observable } from 'rxjs';
import { Projects, Companies, Updates, Users } from 'api/collections';
import { Project, Company } from 'api/models';
import { ProjectHomePage } from '../../pages/project-home/project-home';
// import { subscribeActiveProject } from '../../services/projectData';
import { ProjectService } from '../../services/projectData';
import { App } from "ionic-angular";
import { ISDEV, APP_TITLE } from '../../services/config';
import { HttpService } from '../../services/httpService';
import { AuthenticationService } from '../../services/congito';
import { SharedService } from '../../services/sharedService';

import { Router } from '@angular/router';

@Component({
  template: `
    <ion-header>
      <ion-navbar color="primary">
        <ion-title>Change Active Project</ion-title>
         <ion-buttons right>
          <button ion-button icon-only navPop><ion-icon name="close"></ion-icon></button>
        </ion-buttons>
      </ion-navbar>
    </ion-header>

    <ion-content>
      <ion-item *ngIf="!projects || loading">
        <ion-spinner></ion-spinner>
      </ion-item>
      <ion-list *ngIf="!loading">
        
        <ion-item *ngIf="projects && projects.length === 0">
          <p>You're not a member of any projects</p>
        </ion-item>
        <button ion-item text-wrap *ngFor="let project of projects" (click)="selectProject(project)" detail-push>
          <ion-label>
            <h2>{{project.name}}</h2>
            <p>{{(companyMap[project.companyId] || {}).name}}</p>
          </ion-label>
          <ion-badge item-end *ngIf="isActiveProject(project)">Active</ion-badge>
        </button>
      </ion-list>
    </ion-content>
  `,
})
export class ChooseActiveProjectPage implements OnInit, OnDestroy {
  public isDev = ISDEV;
  loading=false;
  projectsByCompany: {
    [companyId: string]: Project[]
  } = {};
  projects: Project[];
  companyMap: {
    [companyId: string]: Company
  };
  activeProject: Project | void;
  interval:any;
  constructor(
    private _app: App,
    private navCtrl: NavController,
    private alertCtrl: AlertController,
    private menuCtrl: MenuController,
    private events: Events,
    public httpService: HttpService,
    public projectService: ProjectService,
    private sharedService: SharedService,
    public authenticationService: AuthenticationService,
    private router: Router
  ) {}

  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }
  async mainSubscription(){
    const { projectsByCompany, companies } = await this.getData();
    this.activeProject = await this.projectService.subscribeActiveProject();
    this.projectsByCompany = projectsByCompany;
    this.projects = _.orderBy(_.flatten(_.values(this.projectsByCompany)), 'name');
    this.companyMap = _.keyBy(companies, '_id');
  }

  ngOnInit() {
    const autorun = MeteorObservable.autorun();
    // const companyProjects = MeteorObservable.subscribe('projectsAcrossAllCompanies');
    const companyProjects = this.httpService.MeteorSubscribe('projectsAcrossAllCompanies');
    this.mainSubscription();

    this.httpService.privateLoopAction(true).then(()=>{
      this.mainSubscription()
      .then(()=>this.httpService.privateLoopAction(true))
      .then(()=>this.mainSubscription())
      Observable.merge(autorun, companyProjects).subscribe(() => {
        this.mainSubscription()
      });
    });
  }

  ngOnDestroy() { 
    try {
      clearInterval(this.interval);
    } catch(err){

    }
  }

  isActiveProject(project: Project) {
    return this.activeProject && project._id === this.activeProject._id;
  }

  async getData(): Promise<{
    projectsByCompany: {
      [companyId: string]: Project[]
    },
    companies: Company[]
  }> {
    const projects = Projects.find({
      $or: [
        { memberIds: this.authenticationService.MeteorUserId() },
      ]
    }).fetch();
    const projectsByCompany = _.groupBy(projects, project => project.companyId);
    return {
      projectsByCompany,
      companies: Companies.find({ _id: { $in: _.keys(projectsByCompany) } }).fetch(),
    };
  }

  selectProject(project: Project): void {
    
    /*
    MeteorObservable.call('setActiveProject', project._id).subscribe({
      next: () => {
        this.navCtrl.pop();
        this.events.publish('rootNavSetPages', [{ page: ProjectHomePage }]);
        this.menuCtrl.close();
      },
    });
    */
    if(this.loading){
      return;
    }

    this.loading=true;
    this.httpService.MeteorCall('setActiveProject', project._id)
      .then(async () => {
        Users.update({_id: this.authenticationService.MeteorUserId()}, {$set: {"profile.activeProjectId":project._id}});
        await this.httpService.MeteorSubscribe('projectDetails', project._id)
        .then(()=>this.httpService.privateLoopAction(true));
        let executions=0;
        
        this.interval=setInterval(()=>{
          executions++;
          if(Updates.findOne({_id:project.currentUpdateId, archived:{$ne:true}})){
            clearInterval(this.interval);
            if(this.loading){
              this.sharedService.projectChanged.emit(project);
              this.navCtrl.pop();
              this.loading=false;
              this.events.publish('rootNavSetPages', [{ page: ProjectHomePage, params: {projectId:project._id, projectIdReactive:project._id} }]);
              if (project) { // this.project may not be instantiated by the time this code runs, in a cold start
                if (project.name) {
                  // This is done to avoid a timing conflict in Routing, until we upgrade Ionic, to use the Angular Router for navigation
                  // It is re-routed to /projectName/activities, so it looks OK for now
                  this.router.navigate([project.name, 'activities', 'addNewActivityLog']);  
                  //this.router.navigate([project.name, 'activities']);
                }
              }  
              this.menuCtrl.close();
            }
          }

          if(executions>50 || !(project && project.currentUpdateId)){
            clearInterval(this.interval);
            this.sharedService.projectChanged.emit(project);
            this.navCtrl.pop();
            this.loading=false;
            this.events.publish('rootNavSetPages', [{ page: ProjectHomePage, params: {projectId:project._id, projectIdReactive:project._id} }]);
            if (project) { // this.project may not be instantiated by the time this code runs, in a cold start
              if (project.name) {
                // This is done to avoid a timing conflict in Routing, until we upgrade Ionic, to use the Angular Router for navigation
                // It is re-routed to /projectName/activities, so it looks OK for now
                this.router.navigate([project.name, 'activities', 'addNewActivityLog']);  
                //this.router.navigate([project.name, 'activities']);
              }
            }  
            this.menuCtrl.close();
          }


          
        }, 200)


       
      })  
      .catch(err => console.log('meteor call error:', err));
    

  }

  handleError(e: Error): void {
   if(this.isDev == true) {  console.error(e) }

    const alert = this.alertCtrl.create({
      buttons: ['OK'],
      message: e.message,
      title: 'Oops!'
    });

    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/components/choose-active-project/choose-active-project.ts